import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import FormGroup from '../../Components/Form_Group';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import GridModal from '../../Components/Modal_Grid';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BasicModal from '../../Components/Modal_Basic';
import File_Modal from '../../Components/File_Modal';
import CkeckingForm from '../../Components/CkeckingForm';
import Checking from '../../Components/Checking';
import BasicButton from '../../Components/Button_Basic';
import FileForm from '../../Components/FileForm';
import Commons from '../../Services/Common/Common';

function Bm10050(props) {
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [modalToggle, setModalToggle] = React.useState(false);
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const [modalToggle2, setModalToggle2] = React.useState(false);
    const [checkInputs, setCheckInputs] = React.useState({
        value: '',
        value1: '',
    });

    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [selectedModalData1, setSelectedModalData1] = React.useState(null);
    const gridRef = React.useRef();
    // 거래처 정보 팝업 컬럼
    const AuthGroupGridColumnDef = [
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    //담당자 정보 팝업 컬럼
    const AuthGroupGridUserColumn = [
        {
            field: 'userId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserId' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        {
            field: 'userNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
    ];
    //왼쪽 그리드 컬럼
    const columnDefs = [
        {
            field: 'no',
            headerName: 'No',
            minWidth: 110,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: 'plantNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '', //사업장
            cellRenderer: Commons.CustomPlantRenderer,
        },
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //품목코드
        },
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '', //품명
            minWidth: 250,
        },
        {
            field: 'itemStd1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '', //규격
        },
        {
            field: 'lCategoNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '', //대분류
        },
        {
            field: 'mCategoNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Mcategory' && f.lanType === 'COL')[0].lanName
                    : '', //중분류
        },
        {
            field: 'sCategoNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Scategory' && f.lanType === 'COL')[0].lanName
                    : '', //소분류
        },
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PRWhCd' && f.lanType === 'COL')[0].lanName
                    : '', //생산/입고처
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        {
            field: 'custCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustCd' && f.lanType === 'COL')[0].lanName
                    : '', //거래처코드
        },
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '', //거래처명
        },
        {
            field: 'custItemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustItemCd' && f.lanType === 'COL')[0].lanName
                    : '', //고객품목코드
        },
        {
            field: 'itemUnitNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '', //품목단위
        },
        {
            field: 'itemStd2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd2' && f.lanType === 'COL')[0].lanName
                    : '', //규격2
        },
        {
            field: 'itemPeriodDd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemPeriodDt' && f.lanType === 'COL')[0].lanName
                    : '', //유통기간
        },
        {
            field: 'itemAigingDd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemAgingDt' && f.lanType === 'COL')[0].lanName
                    : '', //Aging시간
        },
        {
            field: 'itemQcInspYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQcInspYn' && f.lanType === 'COL')[0].lanName
                    : '', //품질검사여부
        },
        {
            field: 'itemGroupNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemGroupNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목그룹
        },
        {
            field: 'itemCategoNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCategoNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목구분
        },
        {
            field: 'itemTypeNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemTypeNm' && f.lanType === 'COL')[0].lanName
                    : '', //품목타입
        },
        {
            field: 'projectNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProjectNm' && f.lanType === 'COL')[0].lanName
                    : '', //프로젝트명
        },
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStdAmt' && f.lanType === 'COL')[0].lanName
                    : '', //기준단가
        },
        {
            field: 'itemBomYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemBomYn' && f.lanType === 'COL')[0].lanName
                    : '', //BOM생성여부
        },
        {
            field: 'itemVatYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVatYn' && f.lanType === 'COL')[0].lanName
                    : '', //부가세포함여부
        },
        {
            field: 'catonInQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCartonInQty' && f.lanType === 'COL')[0].lanName
                    : '', //카톤입수량
        },
        {
            field: 'userNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UserNm' && f.lanType === 'COL')[0].lanName
                    : '', //사용자이름
        },
        {
            field: 'itemFilename',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_FileNm' && f.lanType === 'COL')[0].lanName
                    : '', //파일명
        },
        {
            field: 'itemQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '', //아이템수량
        },
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '', //납기일
        },
        {
            field: 'itemWonji1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemWonji1' && f.lanType === 'COL')[0].lanName
                    : '', //원지1
        },
        {
            field: 'itemWonji2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemWonji2' && f.lanType === 'COL')[0].lanName
                    : '', //원지2
        },
        {
            field: 'itemPlateMaking',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemPlateMaking' && f.lanType === 'COL')[0].lanName
                    : '', //제판
        },
        {
            field: 'itemPrint',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemPrint' && f.lanType === 'COL')[0].lanName
                    : '', //인쇄
        },
        {
            field: 'itemRamie',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemRamie' && f.lanType === 'COL')[0].lanName
                    : '', //라미
        },
        {
            field: 'itemSpecialPrice1',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemSpecialPrice1' && f.lanType === 'COL')[0].lanName
                    : '', //특수가공1
        },
        {
            field: 'itemSpecialPrice2',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemSpecialPrice2' && f.lanType === 'COL')[0].lanName
                    : '', //특수가공2
        },
        {
            field: 'itemJedae',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemJedae' && f.lanType === 'COL')[0].lanName
                    : '', //제대
        },
        {
            field: 'itemThompson',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemThompson' && f.lanType === 'COL')[0].lanName
                    : '', //톰슨
        },
        {
            field: 'itemString',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemString' && f.lanType === 'COL')[0].lanName
                    : '', //끈
        },
        {
            field: 'itemLaminated',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemLaminated' && f.lanType === 'COL')[0].lanName
                    : '', //합지
        },
        {
            field: 'itemSide',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemSide' && f.lanType === 'COL')[0].lanName
                    : '', //사이드
        },
        {
            field: 'itemPerforated',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemPerforated' && f.lanType === 'COL')[0].lanName
                    : '', //타공
        },
        {
            field: 'itemVinyl',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemVinyl' && f.lanType === 'COL')[0].lanName
                    : '', //비닐
        },
        {
            field: 'itemCarton',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCarton' && f.lanType === 'COL')[0].lanName
                    : '', //카톤
        },
        {
            field: 'itemHole',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemHole' && f.lanType === 'COL')[0].lanName
                    : '', //구멍쇠
        },
        {
            field: 'itemCaution',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCaution' && f.lanType === 'COL')[0].lanName
                    : '', //주의사항
        },
        {
            field: 'itemUpperPod',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUpperPod' && f.lanType === 'COL')[0].lanName
                    : '', //상깍지
        },
        {
            field: 'itemLowPod',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemLowPod' && f.lanType === 'COL')[0].lanName
                    : '', //하깍지
        },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
            minWidth: 150,
            editable: false,
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
            editable: false,
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
            minWidth: 150,
            editable: false,
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
            editable: false,
        },
    ];

    // Row를 선택할때마다 동작하는 Callback함수
    const onSelectionChanged = React.useCallback(() => {
        const selected = gridRef.current.api.getSelectedRows();
        props.setSelectedRowData(selected);
    }, []);
    const AuthGroupSettingClicked = (_data) => {
        setSelectedRowData({ ..._data.data });
        // props.GetSalesOrderItemdtls(saveSoNo);
        setModalToggle(true);
        setCheckInputs({
            ...checkInputs,
            value: '',
        });
        props.setAuthGroupGridRowData([]);
    };
    const AuthGroupUserSettingClicked = (_data) => {
        setSelectedRowData({ ..._data.data });
        // props.GetSalesOrderItemdtls(saveSoNo);
        setModalToggle1(true);
        setCheckInputs({
            ...checkInputs,
            value: '',
        });
        props.setAuthGroupGridRowData([]);
    };
    const onCellClicked = (e) => {
        const selected = e.data;
        props.setInputs({
            ...props.inputs,
            //품목정보
            plantCd: selected.plantCd,
            itemCd: selected.itemCd,
            lCatego: selected.lCatego,
            whCd: selected.whCd,
            mCatego: selected.mCatego,
            sCatego: selected.sCatego,
            custCd: selected.custCd,
            custNm: selected.custNm,
            custItemCd: selected.custItemCd,
            itemNm: selected.itemNm,
            itemUnit: selected.itemUnit,
            itemStd1: selected.itemStd1,
            itemStd2: selected.itemStd2,
            itemFilePath: selected.itemFilePath,
            itemFilename: selected.itemFilename,
            catonInQty: selected.catonInQty,
            itemPeriodDd: selected.itemPeriodDd,
            itemAigingDd: selected.itemAigingDd + '',
            itemQcInspYn: selected.itemQcInspYn,
            itemGroup: selected.itemGroup,
            itemCatego: selected.itemCatego,
            itemType: selected.itemType,
            projectNm: selected.projectNm,
            itemStdAmt: selected.itemStdAmt + '',
            itemBomYn: selected.itemBomYn,
            itemVatYn: selected.itemVatYn,
            remarks: selected.remarks,
            itemFormula: selected.itemFormula,
            whNm: selected.whNm,
            //완제품정보
            personCharg: selected.personCharg ? selected.personCharg : '',
            userNm: selected.userNm ? selected.userNm : '',
            itemQty: selected.itemQty ? selected.itemQty : 0,
            soDueDt: selected.soDueDt ? selected.soDueDt : '',
            itemWonji1: selected.itemWonji1 ? selected.itemWonji1 : '',
            itemWonji2: selected.itemWonji2 ? selected.itemWonji2 : '',
            itemPlateMaking: selected.itemPlateMaking ? selected.itemPlateMaking : '',
            itemPrint: selected.itemPrint ? selected.itemPrint : '',
            itemRamie: selected.itemRamie ? selected.itemRamie : '',
            itemSpecialPrice1: selected.itemSpecialPrice1 ? selected.itemSpecialPrice1 : '',
            itemSpecialPrice2: selected.itemSpecialPrice2 ? selected.itemSpecialPrice2 : '',
            itemJedae: selected.itemJedae ? selected.itemJedae : '',
            itemThompson: selected.itemThompson ? selected.itemThompson : '',
            itemString: selected.itemString ? selected.itemString : '',
            itemLaminated: selected.itemLaminated ? selected.itemLaminated : '',
            itemSide: selected.itemSide ? selected.itemSide : '',
            itemPerforated: selected.itemPerforated ? selected.itemPerforated : '',
            itemVinyl: selected.itemVinyl ? selected.itemVinyl : '',
            itemCarton: selected.itemCarton ? selected.itemCarton : '',
            itemHole: selected.itemHole ? selected.itemHole : '',
            itemCaution: selected.itemCaution ? selected.itemCaution : '',
            itemUpperPod: selected.itemUpperPod ? selected.itemUpperPod : '',
            itemLowPod: selected.itemLowPod ? selected.itemLowPod : '',
        });

        props.setSelectedRowData([
            {
                ...props.selectedRowData,
                plantCd: selected.plantCd,
                itemCd: selected.itemCd,
            },
        ]);
    };

    React.useEffect(() => {
        document.title = '품목관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>품목관리</strong>" +
            '</h1>';
        if (props.checkItemCdToggle === true) {
            props.setInputs({
                ...props.inputs,
                itemCd: props.checkInputs.value1,
            });
        }

        props.setCheckItemCdTolle(false);
    }, [props.checkItemCdToggle]);
    //재사용 버튼
    const refreshBtn = () => {
        props.setInputs({
            ...props.inputs,
            plantCd: '',
            itemCd: '',
            lCatego: '',
            mCatego: '',
            sCatego: '',
            custCd: '',
            custNm: '',
            custItemCd: '',
            itemNm: '',
            itemUnit: '',
            itemStd1: '',
            itemStd2: '',
            itemPeriodDd: '',
            itemAigingDd: '',
            itemQcInspYn: 'N',
            itemGroup: '',
            itemCatego: '',
            itemType: 'ITEM_TYPE_01',
            projectNm: '',
            itemStdAmt: '',
            itemBomYn: 'N',
            itemVatYn: 'N',
            remarks: '',
            businesCloseDt: '',
            //완제품정보
            personCharg: '',
            userNm: '',
            itemQty: 0,
            soDueDt: '',
            itemWonji1: '',
            itemWonji2: '',
            itemPlateMaking: '',
            itemPrint: '',
            itemRamie: '',
            itemSpecialPrice1: '',
            itemSpecialPrice2: '',
            itemJedae: '',
            itemThompson: '',
            itemString: '',
            itemLaminated: '',
            itemSide: '',
            itemPerforated: '',
            itemVinyl: '',
            itemCarton: '',
            itemHole: '',
            itemCaution: '',
            itemUpperPod: '',
            itemLowPod: '',
        });
    };
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '60%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    {/* 왼쪽 그리드 버튼 */}
                    <AuthGroupButton
                        pageName="BM10040"
                        target="G01"
                        refreshNone="none"
                        addFunc={() => {
                            gridRef.current.api.setRowData([{}, ...props.rowData]);
                        }}
                        saveFunc={() => props.SaveConfirm()}
                        deleteFunc={() => props.DeleteConfirm()}
                    />
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    {/* 왼쪽 그리드 */}
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onGridReady={
                            (e) => e.api.sizeColumnsToFit()
                            // GridFunctions.onCellValueChanged(
                            //   e,
                            //   gridRef,
                            //   props.setChangedRowData
                            // )
                        }
                        setAlwaysShowHorizontalScroll={true}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </div>
            <div style={{ width: '40%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    {/* 복사 버튼 */}
                    <BasicButton
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Copy' && f.lanType === 'BTN')[0].lanName
                                : ''
                        }
                        onClick={() => props.setModalToggle(true)}
                    />
                    {/* 오른쪽 그리드 버튼 */}
                    <AuthGroupButton
                        pageName="BM10040"
                        target="F01"
                        refreshFunc={() => {
                            refreshBtn();
                            props.setSelectedRowData([]);
                        }}
                        addFunc={() => {
                            refreshBtn();
                            props.setModalToggle(true);
                        }}
                        saveFunc={() => props.SaveConfirm()}
                        deleteFunc={() => props.DeleteConfirm()}
                    />
                </Card>

                <Card style={{ height: '770px', marginTop: '0px', overflow: 'scroll' }}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>
                                {props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Fom_ItemInfo' && f.lanType === 'FORM')[0]
                                          .lanName
                                    : ''}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormGroup
                                datas={[
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목코드
                                        required: true,
                                        inputClass: 'input',
                                        value: props.inputs.itemCd ? props.inputs.itemCd : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemCd: value,
                                            });
                                        },
                                        readOnly: true,
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_PlantCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //사업장 코드
                                        inputClass: 'input',
                                        combos: props.inputs.comboPlantList,
                                        value: props.inputs.plantCd ? props.inputs.plantCd : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                plantCd: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목명
                                        inputClass: 'input',
                                        value: props.inputs.itemNm ? props.inputs.itemNm : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemNm: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_Lcategory' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //대분류
                                        inputClass: 'input',
                                        combos: props.inputs.comboLCatego,
                                        value: props.inputs.lCatego ? props.inputs.lCatego : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                lCatego: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_Mcategory' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //중분류
                                        inputClass: 'input',
                                        combos: props.inputs.comboMCatego,
                                        value: props.inputs.mCatego ? props.inputs.mCatego : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                mCatego: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_Scategory' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //소분류
                                        inputClass: 'input',
                                        combos: props.inputs.comboSCatego,
                                        value: props.inputs.sCatego ? props.inputs.sCatego : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                sCatego: e,
                                            });
                                        },
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_CustCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //거래처코드
                                        value: props.inputs.custCd ? props.inputs.custCd : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                custCd: e.target.value,
                                            });
                                        },
                                        clicked: true,
                                        onClick: (e) => {
                                            AuthGroupSettingClicked(e);
                                            props.setInputs({
                                                ...props.inputs,

                                                //custCd: "",
                                                //custNm: "",

                                                arrivCustCd: '',
                                            });
                                            // props.setRowData1([]);
                                        },
                                        readOnly: true,
                                        required: true,
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_CustNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //거래처명
                                        value: props.inputs.custNm ? props.inputs.custNm : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                custNm: e.target.value,
                                            });
                                        },
                                        readOnly: true,
                                        // required: true,
                                    },
                                    // {
                                    //   type: "input",
                                    //   name: "거래처코드",
                                    //   inputClass: "input",
                                    //   value: props.inputs.custCd ? props.inputs.custCd : "",
                                    //   onChange: (e) => {
                                    //     let { value } = { ...e.target };
                                    //     props.setInputs({
                                    //       ...props.inputs,
                                    //       custCd: value,
                                    //     });
                                    //   },
                                    // },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_CustItemCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //고객사품목코드
                                        inputClass: 'input',
                                        value: props.inputs.custItemCd ? props.inputs.custItemCd : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                custItemCd: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemUnit' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목단위
                                        inputClass: 'input',
                                        combos: props.inputs.comboUnitList,
                                        value: props.inputs.itemUnit ? props.inputs.itemUnit : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemUnit: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemStd1' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //규격1
                                        inputClass: 'input',
                                        value: props.inputs.itemStd1 ? props.inputs.itemStd1 : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemStd1: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemStd2' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //규격2
                                        inputClass: 'input',
                                        value: props.inputs.itemStd2 ? props.inputs.itemStd2 : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemStd2: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'date',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemPeriodDt' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //유통기간
                                        inputClass: 'input',
                                        inputType: 'number',
                                        value: props.inputs.itemPeriodDd ? props.inputs.itemPeriodDd : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemPeriodDd: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemAgingDt' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //Aging시간
                                        inputClass: 'input',
                                        inputType: 'number',
                                        value: props.inputs.itemAigingDd ? props.inputs.itemAigingDd : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemAigingDd: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'radio',
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemQcInspYn' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품질검사여부
                                        items: [
                                            {
                                                value: 'Y',
                                                name: 'Y',
                                            },
                                            {
                                                value: 'N',
                                                name: 'N',
                                            },
                                        ],
                                        value: props.inputs.itemQcInspYn,
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemQcInspYn: e.target.value,
                                            });
                                        },
                                        gubun: '1',
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemGroupNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목그룹
                                        inputClass: 'input',
                                        combos: props.inputs.comboGroup,
                                        value: props.inputs.itemGroup ? props.inputs.itemGroup : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemGroup: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemCategoNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목카테고리
                                        inputClass: 'input',
                                        combos: props.inputs.comboCatego,
                                        value: props.inputs.itemCatego ? props.inputs.itemCatego : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemCatego: e,
                                            });
                                        },
                                    },

                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemTypeNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목타입
                                        combos: props.inputs.comboList,
                                        value: props.inputs.itemType ? props.inputs.itemType : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemType: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ProjectNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //프로젝트명
                                        inputClass: 'input',
                                        value: props.inputs.projectNm ? props.inputs.projectNm : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                projectNm: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemStdAmt' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //기준단가
                                        inputClass: 'input',
                                        inputType: 'number',
                                        value: props.inputs.itemStdAmt ? props.inputs.itemStdAmt : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemStdAmt: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'radio',
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemBomYn' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //BOM생성여부
                                        items: [
                                            {
                                                value: 'Y',
                                                name: 'Y',
                                            },
                                            {
                                                value: 'N',
                                                name: 'N',
                                            },
                                        ],
                                        value: props.inputs.itemBomYn,
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemBomYn: e.target.value,
                                            });
                                        },
                                        gubun: '4',
                                    },
                                    {
                                        type: 'radio',
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemVatYn' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //부가세여부
                                        items: [
                                            {
                                                value: 'Y',
                                                name: 'Y',
                                            },
                                            {
                                                value: 'N',
                                                name: 'N',
                                            },
                                        ],
                                        value: props.inputs.itemVatYn,
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                itemVatYn: e.target.value,
                                            });
                                        },
                                        gubun: '2',
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemFormula' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //계산식
                                        inputClass: 'input',
                                        value: props.inputs.itemFormula ? props.inputs.itemFormula : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemFormula: value,
                                            });
                                        },
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_userNm' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //담당자
                                        value: props.inputs.userNm ? props.inputs.userNm : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                userNm: e.target.value,
                                            });
                                        },
                                        clicked: true,
                                        onClick: (e) => {
                                            AuthGroupUserSettingClicked(e);
                                            props.setInputs({
                                                ...props.inputs,

                                                // userNm: "",
                                            });
                                            // props.setRowData1([]);
                                        },
                                        readOnly: true,
                                        required: true,
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_Remark' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //비고
                                        inputClass: 'input',
                                        value: props.inputs.remarks ? props.inputs.remarks : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                remarks: value,
                                            });
                                        },
                                    },
                                    {
                                        type: 'combo',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_WhCd' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //생산/입고처
                                        combos:
                                            props.inputs.itemType == 'ITEM_TYPE_01' ||
                                            props.inputs.itemType == 'ITEM_TYPE_04' ||
                                            props.inputs.itemTyep == 'ITEM_TYPE_05'
                                                ? props.inputs.comboWhCd.filter(
                                                      (x) => x.value.substring(3, 5) == 'MM' || x.value == ''
                                                  )
                                                : props.inputs.comboWhCd.filter(
                                                      (x) => x.value.substring(3, 5) == 'IN' || x.value == ''
                                                  ),
                                        value: props.inputs.whCd ? props.inputs.whCd : '',
                                        onChange: (e) => {
                                            props.setInputs({
                                                ...props.inputs,
                                                whCd: e,
                                            });
                                        },
                                    },
                                    {
                                        type: 'button',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ImageUpload' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //파일업로드
                                        btnName:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Btn_Upload' && f.lanType === 'BTN'
                                                  )[0].lanName
                                                : '', //업로드 버튼
                                        onClick: (e) => {
                                            setModalToggle2(true);
                                        },
                                    },
                                    {
                                        type: 'input',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemCartonInQty' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //카톤입수량
                                        inputClass: 'input',
                                        value: props.inputs.catonInQty ? props.inputs.catonInQty : '',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                catonInQty: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType === 'ITEM_TYPE_01' ? false : true,
                                    },
                                ]}
                            />
                        </AccordionDetails>
                    </Accordion>
                    {/* </Card> */}
                    {/* <Card style={{ height: "300px", marginTop: "0px" }}> */}
                    <Accordion disabled={props.inputs.itemType != 'ITEM_TYPE_01' ? true : false}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>
                                {props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Fom_FinishedProductInfo' && f.lanType === 'FORM'
                                      )[0].lanName
                                    : ''}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FormGroup
                                datas={[
                                    {
                                        type: 'itemQty',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemQty' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //품목 수량
                                        inputClass: 'input',
                                        value: props.inputs.itemQty,
                                        inputType: 'number',
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemQty: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'soDueDt',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_SoDueDt' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //납기일
                                        inputClass: 'input',
                                        value: props.inputs.soDueDt,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                soDueDt: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        fullWidth: true,
                                        type: 'itemWonji1',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemWonji1' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //원지1
                                        inputClass: 'input',
                                        value: props.inputs.itemWonji1,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemWonji1: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        fullWidth: true,

                                        type: 'itemWonji2',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemWonji2' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //원지2
                                        inputClass: 'input',
                                        value: props.inputs.itemWonji2,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemWonji2: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },

                                    {
                                        type: 'itemPlateMaking',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemPlateMaking' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //제판
                                        inputClass: 'input',
                                        value: props.inputs.itemPlateMaking,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemPlateMaking: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemRamie',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemRamie' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //라미
                                        inputClass: 'input',
                                        value: props.inputs.itemRamie,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemRamie: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        fullWidth: true,
                                        type: 'itemPrint',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemPrint' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //인쇄
                                        inputClass: 'input',
                                        value: props.inputs.itemPrint,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemPrint: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemSpecialPrice1',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemSpecialPrice1' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //특수가공1
                                        inputClass: 'input',
                                        value: props.inputs.itemSpecialPrice1,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemSpecialPrice1: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },

                                    {
                                        type: 'itemSpecialPrice2',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemSpecialPrice2' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //특수가공2
                                        inputClass: 'input',
                                        value: props.inputs.itemSpecialPrice2,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemSpecialPrice2: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemJedae',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemJedae' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //제대
                                        inputClass: 'input',
                                        value: props.inputs.itemJedae,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemJedae: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemThompson',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemThompson' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //톰슨
                                        inputClass: 'input',
                                        value: props.inputs.itemThompson,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemThompson: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemString',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemString' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //끈
                                        inputClass: 'input',
                                        value: props.inputs.itemString,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemString: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemLaminated',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemLaminated' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //합지
                                        inputClass: 'input',
                                        value: props.inputs.itemLaminated,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemLaminated: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemSide',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemSide' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //사이드
                                        inputClass: 'input',
                                        value: props.inputs.itemSide,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemSide: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemPerforated',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemPerforated' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //타공
                                        inputClass: 'input',
                                        value: props.inputs.itemPerforated,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemPerforated: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemVinyl',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemVinyl' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //비닐
                                        inputClass: 'input',
                                        value: props.inputs.itemVinyl,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemVinyl: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemCarton',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemCarton' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //카톤
                                        inputClass: 'input',
                                        value: props.inputs.itemCarton,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemCarton: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemHole',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemHole' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //구멍쇠
                                        inputClass: 'input',
                                        value: props.inputs.itemHole,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemHole: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemCaution',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemCaution' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //주의사항
                                        inputClass: 'input',
                                        value: props.inputs.itemCaution,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemCaution: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemUpperPod',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemUpperPod' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //상깍지
                                        inputClass: 'input',
                                        value: props.inputs.itemUpperPod,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemUpperPod: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                    {
                                        type: 'itemLowPod',
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Fom_ItemLowPod' && f.lanType === 'FORM'
                                                  )[0].lanName
                                                : '', //하깍지
                                        inputClass: 'input',
                                        value: props.inputs.itemLowPod,
                                        onChange: (e) => {
                                            let { value } = { ...e.target };
                                            props.setInputs({
                                                ...props.inputs,
                                                itemLowPod: value,
                                            });
                                        },
                                        readOnly: props.inputs.itemType != 'ITEM_TYPE_01' ? true : false,
                                    },
                                ]}
                            />
                        </AccordionDetails>
                    </Accordion>
                </Card>
                <Section />
            </div>
            <div>
                {/* 거래처 정보 팝업 */}
                {modalToggle && (
                    <GridModal
                        conditions={[
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Dia_CustCd' && f.lanType === 'DIALOG'
                                          )[0].lanName
                                        : '',
                                value: checkInputs.value,
                                onChange: (e) => {
                                    setCheckInputs({
                                        ...checkInputs,
                                        value: e.target.value,
                                    });
                                },
                                onClick: (e) => {
                                    // document.getElementsByName("품목코드/명").focus;
                                },
                                onKeyDown: (e) => {
                                    props.CustNmHelper(checkInputs.value);
                                },
                            },
                            {
                                type: 'button',
                                style: {
                                    width: '100px',
                                },
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '',
                                onClick: (e) => {
                                    props.CustNmHelper(checkInputs.value);
                                },
                            },
                        ]}
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Dia_CustInfo' && f.lanType === 'DIALOG')[0]
                                      .lanName
                                : ''
                        }
                        onClose={() => setModalToggle(false)}
                        gridColumn={AuthGroupGridColumnDef}
                        gridRowData={props.authGroupGridRowData}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                                : ''
                        }
                        gridOnClick={(e) => {
                            let data = [];
                            for (let i = 0; i < e.length; i++) {
                                data.push({
                                    custCd: e[i].custCd,
                                    custNm: e[i].custNm,
                                    arrivCustCd: e[i].arrivCustCd,
                                });
                            }
                            setSelectedModalData(data);
                        }}
                        gridOnDoubleClick={(e) => false}
                        execLogic={() => {
                            props.setInputs({
                                ...props.inputs,
                                custCd: selectedModalData[0].custCd,
                                custNm: selectedModalData[0].custNm,
                            });
                        }}
                    />
                )}
                {/* 담당자 팝업 */}
                {modalToggle1 && (
                    <GridModal
                        conditions={[
                            {
                                type: 'input',
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Dia_UserId' && f.lanType === 'DIALOG'
                                          )[0].lanName
                                        : '',
                                value: checkInputs.value1,
                                onChange: (e) => {
                                    setCheckInputs({
                                        ...checkInputs,
                                        value1: e.target.value,
                                    });
                                },
                                onClick: (e) => {
                                    // document.getElementsByName("품목코드/명").focus;
                                },
                                onKeyDown: (e) => {
                                    props.UserNmHelper(checkInputs.value1);
                                },
                            },
                            {
                                type: 'button',
                                style: {
                                    width: '100px',
                                },
                                name:
                                    props.lanData.length > 0
                                        ? props.lanData.filter(
                                              (f) => f.lanId === 'Btn_Search' && f.lanType === 'BTN'
                                          )[0].lanName
                                        : '',
                                onClick: (e) => {
                                    props.UserNmHelper(checkInputs.value1);
                                },
                            },
                        ]}
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Dia_UserInfo' && f.lanType === 'DIALOG')[0]
                                      .lanName
                                : ''
                        }
                        onClose={() => setModalToggle1(false)}
                        gridColumn={AuthGroupGridUserColumn}
                        gridRowData={props.authGroupGridUserData}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                                : ''
                        }
                        gridOnClick={(e) => {
                            let data = [];
                            for (let i = 0; i < e.length; i++) {
                                data.push({
                                    userId: e[i].userId,
                                    userNm: e[i].userNm,
                                });
                            }
                            setSelectedModalData1(data);
                        }}
                        gridOnDoubleClick={(e) => false}
                        execLogic={() => {
                            props.setInputs({
                                ...props.inputs,
                                personCharg: selectedModalData1[0].userId,
                                userNm: selectedModalData1[0].userNm,
                            });
                        }}
                    />
                )}
                {/* 품목코드 체크 팝업 */}
                {props.modalToggle && (
                    <BasicModal
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Dia_ItemManageMent' && f.lanType === 'DIALOG'
                                  )[0].lanName
                                : '' //품목관리
                        }
                        onClose={() => props.setModalToggle(false)}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0].lanName
                                : '' //검사
                        }
                        execLogic={() => {
                            props.CheckCusCd();
                        }}
                    >
                        <CkeckingForm
                            datas={[
                                {
                                    type: 'combo',
                                    combos: props.checkInputs.comboExport,
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_Domestic/Export' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //내수/수출
                                    value: props.checkInputs.exportValue,
                                    onChange: (e) => {
                                        props.setCheckInputs({
                                            ...props.checkInputs,
                                            exportValue: e,
                                        });
                                    },
                                },
                                {
                                    type: 'combo',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_OrderArea' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //오더지역
                                    combos: props.checkInputs.comboRegion,
                                    value: props.checkInputs.regionValue,
                                    onChange: (e) => {
                                        props.setCheckInputs({
                                            ...props.checkInputs,
                                            regionValue: e,
                                        });
                                    },
                                },
                                {
                                    type: 'combo',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Fom_CustomerCd' && f.lanType === 'FORM'
                                              )[0].lanName
                                            : '', //고객코드
                                    combos: props.checkInputs.comboCustomer,
                                    value: props.checkInputs.customerValue,
                                    onChange: (e) => {
                                        props.setCheckInputs({
                                            ...props.checkInputs,
                                            customerValue: e,
                                        });
                                    },
                                },
                            ]}
                        />
                    </BasicModal>
                )}
                {modalToggle2 && (
                    <File_Modal
                        name={
                            props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Dia_ImageAttachment' && f.lanType === 'DIALOG'
                                  )[0].lanName
                                : ''
                        }
                        onClose={() => setModalToggle2(false)}
                        buttonName1={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Upload' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        buttonName5={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Download' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        deleteButton={
                            props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Delete' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''
                        }
                        execLogic={() => props.FileConfirm()}
                        downLogic={() => props.FileDownConfirm()}
                        deleteLogic={() => props.FileDeleteConfirm()}
                    >
                        <FileForm
                            datas={[
                                {
                                    type: 'file',
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Dia_File' && f.lanType === 'DIALOG'
                                              )[0].lanName
                                            : '', //파일명
                                    value: props.inputs.itemFilePath ? props.inputs.itemFilePath : '',
                                    onChange: (e) => {
                                        var file = e.target.files[0];
                                        props.setFile(file);
                                        props.setFileName(file.name);
                                        if (e.target.files.length === 0) {
                                            return;
                                        } else {
                                            let reader = new FileReader();
                                            reader.readAsDataURL(file);
                                            reader.onload = (f) => {
                                                document.getElementById('imageFile').src = f.target.result;
                                                if (reader) {
                                                    props.setInputs({
                                                        ...props.inputs,
                                                        fileSize: file,
                                                        itemFilePath: reader.result,
                                                        itemFilename: file.name,
                                                    });
                                                }
                                            };
                                        }
                                    },
                                },
                                {
                                    name:
                                        props.lanData.length > 0
                                            ? props.lanData.filter(
                                                  (f) => f.lanId === 'Dia_FileNm' && f.lanType === 'DIALOG'
                                              )[0].lanName
                                            : '', //파일명
                                    value: props.inputs.itemFilename ? props.inputs.itemFilename : '',
                                    disabled: true,
                                },
                                {
                                    type: 'image',
                                    id: 'imageFile',
                                    src: props.inputs.itemFilePath,
                                },
                            ]}
                        />
                    </File_Modal>
                )}
                <img id="preview" />
            </div>
        </div>
    );
}

export default Bm10050;
